import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";

import HeartIcon from "mdi-react/HeartIcon"
import CommentIcon from "mdi-react/CommentIcon"
import AccountMultipleIcon from "mdi-react/AccountMultipleIcon"
import MessageIcon from "mdi-react/MessageIcon"
import NoteIcon from "mdi-react/NoteIcon"
import CashUsdIcon from "mdi-react/CashUsdIcon"
import CongratulationsModal from "../utils/Utilities/CongratulationsModal";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ArrowRightCircleIcon from "mdi-react/ArrowRightCircleIcon"
import ProgressBar from "../utils/Utilities/ProgressBar";
import LoadingHelper from "../utils/Utilities/LoadingHelper";


class Achievements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            achievementsList: this.props.myDataProvider.achievementsList,
            isClaiming: false,
            congratulationsModal: false,
            moneyEarned: 0,
            error: "",
            sucess: false,
        }
    }

    componentDidMount = () => {
        try {
            this.props.myDataProvider.setNewAchievement(false)
        } catch (error) {
            Aux.handleError(error)
        }
    }

    OnClaimReward = async (id) => {
        if (this.state.isClaiming)
            return;

        try {
            this.setState({ isClaiming: true, error: "" })
            await Fire.shared.claimRewardAchivement(id, this.state.achievementsList[id].reward)
                .then((gotRewarded) => {
                    if (gotRewarded) {
                        let list = this.state.achievementsList
                        if (id !== 0) {
                            list[id].state = "rewarded";
                        }

                        this.setState({ achievementsList: list, congratulationsModal: !this.state.congratulationsModal, moneyEarned: this.state.achievementsList[id].reward })
                    } else {
                        this.setState({ isClaiming: false, error: "An error has occurred" })
                    }
                })
            this.setState({ isClaiming: false })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ isClaiming: false, error: "An error has occurred" })
        }
    }

    closeModal = () => {
        this.setState({ congratulationsModal: !this.state.congratulationsModal, })
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToDailyRewards = () => {
        try{
            this.props.history.push("/account/daily")
        }catch(error){
            Aux.handleError(error)
        }
    }

    goToInviteFriends = () => {
        try{
            this.props.history.push("/account/invitefriends")
        }catch(error){
            Aux.handleError(error)
        }
    }

    GetAchievementIcon = (type, isComplete) => {
        switch (type) {
            case "likes":
                return <HeartIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "comment":
                return <CommentIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "referral":
                return <AccountMultipleIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "send_message":
                return <MessageIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "post":
                return <NoteIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "comment_total":
                return <CommentIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            case "spend_total":
                return <CashUsdIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
            default:
                return <HeartIcon size={20} style={{ color: isComplete ? "white" : Colors.mainColor }} />
        }
    }

    SingleAchievement = (id) => {
        let achivement = this.state.achievementsList[id];
        var isComplete = achivement.state === "rewarded";

        return (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "20px 0px", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width:"100%" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width:"100%" }}>
                        <div style={{
                            display: "flex", justifyContent: "center", alignItems: "center",
                            borderRadius: 50, minHeight: 50, minWidth: 50, borderWidth: 3,
                            borderColor: isComplete ? Colors.green : Colors.mainColor, borderStyle: "solid", backgroundColor: isComplete ? Colors.green : "white",
                        }}>
                            {this.GetAchievementIcon(achivement.type, isComplete)}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", width:"100%", margin:"0 20px"}}>
                            <h3 style={{ color: Colors.darkText, }}>Earn {achivement.reward}$</h3>
                            <ProgressBar percentage={(achivement.currentlyHave/achivement.toComplete) * 100}></ProgressBar>
                            <div style={{ }}>
                                <span>{achivement.text}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {achivement.state === "complete" ? (
                    <div>
                        <ButtonLoader
                            text="Claim"
                            loading={this.state.isClaiming}
                            onClick={() => this.OnClaimReward(id)}
                            style={{ backgroundColor: Colors.mainColor, height: 45, minWidth: 100, width: 100, borderRadius: 15, margin: 0 }}
                        />
                    </div>
                ) : achivement.state === "rewarded" ? (null) : (
                    <div style={{ display: "flex", borderRadius: 15, height: 45, minWidth: 100, width: 100, borderWidth: 3, borderColor: Colors.mainColor, borderStyle: "solid", justifyContent: "center", alignItems: "center" }}>
                        <span style={{ color: Colors.mainColor, fontSize: 16, fontWeight: "bold" }}>
                            {achivement.currentlyHave}/{achivement.toComplete}
                        </span>
                    </div>

                )}
            </div>
        )
    }

    LikesAchievement = (id) => {
        let achivement = this.state.achievementsList[id];

        return (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "10px 0px", alignItems: "center", border:"1px solid #ccc", borderRadius:10, padding:10 }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width:"100%" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width:"100%" }}>
                        {/* <div style={{
                            display: "flex", justifyContent: "center", alignItems: "center",
                            borderRadius: 50, minHeight: 50, minWidth: 50, borderWidth: 3,
                            borderColor: isComplete ? Colors.green : Colors.mainColor, borderStyle: "solid", backgroundColor: isComplete ? Colors.green : "white",
                        }}>
                            {this.GetAchievementIcon(achivement.type, isComplete)}
                        </div> */}
                        <div style={{ display: "flex", flexDirection: "column", width:"100%", margin:"0 20px"}}>
                            <h3 style={{ color: Colors.darkText, }}>Likes</h3>
                            <ProgressBar percentage={(achivement.currentlyHave/achivement.toComplete) * 100}></ProgressBar>
                            <div style={{ }}>
                                <span>Every 10 likes get 1$</span>
                            </div>
                        </div>
                    </div>
                </div>
                {achivement.state === "complete" ? (
                    <div>
                        <ButtonLoader
                            text="Claim"
                            loading={this.state.isClaiming}
                            onClick={() => this.OnClaimReward(id)}
                            style={{ backgroundColor: Colors.mainColor, height: 45, minWidth: 100, width: 100, borderRadius: 15, margin: 0 }}
                        />
                    </div>
                ) : achivement.state === "rewarded" ? (null) : (
                    <div style={{ display: "flex", borderRadius: 15, height: 45, minWidth: 100, width: 100, borderWidth: 3, borderColor: Colors.mainColor, borderStyle: "solid", justifyContent: "center", alignItems: "center" }}>
                        <span style={{ color: Colors.mainColor, fontSize: 16, fontWeight: "bold" }}>
                            {achivement.currentlyHave}/{achivement.toComplete}
                        </span>
                    </div>

                )}
            </div>
        )
    }

    earnDetails = () => {
        return (
            <div style={{display:"flex", margin:"10px 0", padding:10, border: "1px solid #ccc", borderRadius:5}}>
                <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <h3 style={{textAlign:"center"}}>Referral</h3>
                    <div  style={{display:"flex", flexDirection:"row"}}>
                        <span style={{textAlign:"center", marginLeft:15, fontSize:12, color:"#999"}}>earn 10$ for each referral</span>
                        <ArrowRightCircleIcon color={Colors.mainColor} style={{marginTop:5}} className="button-hover" onClick={this.goToInviteFriends}></ArrowRightCircleIcon>
                    </div>
                </div>
                <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <h3 style={{textAlign:"center"}} >Daily Reward</h3>
                    <div  style={{display:"flex", flexDirection:"row"}}>
                        <span style={{textAlign:"center", marginLeft:15, fontSize:12, color:"#999"}}>earn currency each day</span>
                        <ArrowRightCircleIcon color={Colors.mainColor} style={{marginTop:5}} className="button-hover" onClick={this.goToDailyRewards}></ArrowRightCircleIcon>
                    </div>
                    {/* <span style={{textAlign:"center", margin:"5px 15px", fontSize:15, color:Colors.mainColor}}>go to</span> */}
                </div>
                <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <h3 style={{textAlign:"center"}}>Comments</h3>
                    <span style={{textAlign:"center", margin:"0px 15px", fontSize:12, color:"#999"}}>earn for every comment on your posts</span>
                </div>
            </div>
        )
    }

    render() {

        return (
            <div style={{ width: "100%" }}>
                <CongratulationsModal active={this.state.congratulationsModal} onClose={this.closeModal} coins={this.state.moneyEarned}></CongratulationsModal>
                <section className="container login" >
                    <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center", marginBottom: 30 }} onClick={this.goBack}>
                        <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                        <h2>{"Earn & Achievements"}</h2>
                    </div>
                    {/* <span>Did you forgot your password?  </span> */}
                    <ErrorMessage text={this.state.error}></ErrorMessage>
                    {this.props.myDataProvider.user ?

                        <div style={{display:"flex", flexDirection:"column"}}>
                            
                            <h5>Earn</h5>
                            <div>
                                {this.LikesAchievement(0)}
                                <this.earnDetails></this.earnDetails>
                            </div>
                            <div style={{marginTop:10}}>
                                <h5>Achievements</h5>
                            </div>
                            {this.state.achievementsList.map((achiv, index) => {
                                return achiv.id === 0 ? null : <div key={index}>{this.SingleAchievement(achiv.id)}</div>
                            })}
                        </div>
                        :
                        <LoadingHelper/>

                    }

                </section>
            </div>
        );
    }
}

export default withMyDataContext(Achievements);